import { calculateFinances, UserData } from "../../../constants";

const SummaryWhy1 = {
  label: 'Why Invest',
  hide: true,
  sections: [
    {
      type: 'text',
      text: (data: UserData) => {
        const taxData = calculateFinances(data);
        return `
        <h5>${
          data.firstName ? `${data.firstName}, ` : ''
          } You could've made up to Rs. ${Math.round(
            taxData.totalTaxSavings
          ).toLocaleString('en-IN')} more last year</h5>
        <div class="sunshine-block">
          <ul>
            <li><label>Age</label><span>${data.age}</span></li>
            <li><label>Income</label><span>Rs.${data.income.toLocaleString(
            'en-IN'
          )}</span></li>
            <li><label>Tax Savings</label><span>Rs.${data.investments80C.toLocaleString(
            'en-IN'
          )}</span></li>
            ${
          data.married
            ? `<li><label>Marital Status</label><span>${
            data.married
            }</span></li>`
            : ''
          }
            ${
          data.deduction80DInsurance
            ? `<li><label>Health Insurance</label><span>${
            data.deduction80DInsurance
            }</span></li>`
            : ''
          }
            ${
          data.homeLoan
            ? `<li><label>Home Ownership</label><span>${
            data.homeLoan
            }</span></li>`
            : ''
          }
          </ul>
          <div class="analysis">
            We analyzed your data.<br/>
            You could've made up to<br />
            <span>Rs.${Math.round(taxData.totalTaxSavings).toLocaleString(
            'en-IN'
          )}</span><br />
            more last year.
          </div>
        </div>
          <p class="light">
            ClearTax will show you how in the next step.
          </p>
        `;
      },
    },
  ]
};

export default SummaryWhy1;



// WEBPACK FOOTER //
// ./components/recommendation/cards/summaryWhy1.ts